export default "__VITE_ASSET__Bjaf4tj7__"